import { Link } from "react-router-dom";
const SupplierTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item" role="presentation">
        <Link
          to={"/visaprices"}
          className={
            props.pageName === "PRICES"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          PRICES
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/requests"}
          className={
            props.pageName === "REQUESTS"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          REQUESTS
        </Link>
      </li>
    </ul>
  );
};

export default SupplierTabs;
